import React from 'react';
import {
  ColorGradient,
  ColorGradientProps,
  ColorGradientChangeEvent
} from '@progress/kendo-react-inputs';

type KendoReactColorGradientProps = Omit<ColorGradientProps, 'onChange'> & {
  onChange?: (hexColor: string) => void;
};

const KendoReactColorGradient = ({
  onChange,
  ...props
}: KendoReactColorGradientProps) => {
  const handleChange = (event: ColorGradientChangeEvent) => {
    if (onChange) {
      const hexColor = rgbToHex(event.value);
      onChange(hexColor);
    }
  };

  const rgbToHex = (rgb: string): string => {
    const match = rgb.match(/\d+/g);
    if (!match) return '000000';
    return match
      .slice(0, 3)
      .map((x) => parseInt(x).toString(16).padStart(2, '0'))
      .join('');
  };

  return (
    <>
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <ColorGradient
        {...props}
        onChange={handleChange}
        className="kendo-react-color-gradient"
      />
    </>
  );
};

export default KendoReactColorGradient;
